<script lang="ts" setup>
import { shallowRef, watch } from 'vue'
import IconArea from '@lahaus-roomie/roomie/src/assets/icons/area.svg'
import IconBed from '@lahaus-roomie/roomie/src/assets/icons/bed.svg'
import IconToilet from '@lahaus-roomie/roomie/src/assets/icons/toilet.svg'
import IconCar from '@lahaus-roomie/roomie/src/assets/icons/car.svg'

import type { Props } from './types'

const props = withDefaults(defineProps<Props>(), {
  hiddenElements: () => []
})

const generateUnitData = () => [
  {
    icon: IconArea,
    value: props.data?.areaTotal ? `${(props.data?.areaTotal as number).toFixed(0)}m\u00B2` : ''
  },
  {
    icon: IconBed,
    value: props.data?.bedroom
  },
  {
    icon: IconToilet,
    value: props.data?.bathroom
  },
  {
    icon: IconCar,
    value: props.data?.parkingLots
  }
]

const showElement = (index: number) => !(props.hiddenElements.includes(index))

const unitData = shallowRef(generateUnitData())

watch(() => props.data, () => {
  unitData.value = generateUnitData()
})
</script>

<script lang="ts">
export default {
  name: 'AppIconsBar'
}
</script>

<template>
  <div class="flex items-center gap-4 icon-bar">
    <template
      v-for="(data, index) in unitData"
      :key="index">
      <span
        v-if="showElement(index)"
        class="icon-bar__icon w-24 h-24 fill-carbon-light-800 pointer-events-none">
        <component :is="data.icon" />
      </span>

      <span
        v-if="showElement(index)"
        class="icon-bar__text text-16">
        {{ data.value || 0 }}
      </span>

      <span
        v-if="index !== unitData.length - 1 && data.value"
        class="text-carbon-600">
        ·
      </span>
    </template>
  </div>
</template>
